import axios from 'axios'
import * as vars from './vars';

export function getUnreadMessageCount(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/GetUnreadMessageCount',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

// participantId: userId, startTime: long, endTime: long
export function getThreads (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/messaging/GetAllThreads`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function getThread (threadId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/messaging/GetMessageThread`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {threadId: threadId}
    })
}

export function getAiChatThread (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/GetAIChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function readAIChat (jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/ReadAIChatThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {}
    })
}

export function askAI (message, collegeName, ipedsid, jwt){
    const data = {message: message}

    if (collegeName) {
        data['collegeName'] = collegeName;
    }

    if (ipedsid) {
        data['ipedsid'] = ipedsid
    }

    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/AskAI',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
}

export function markThreadAsRead (threadId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/messaging/ReadThread`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {threadId: threadId}
    })
}

export function archiveThread (threadId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/messaging/ArchiveThread`,
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {threadId: threadId}
    })
}

// data = {
//     participantIds: [userId, userId],
//     senderId: userId,
//     subject: String,
//     message: String,
//     messageType: [“Audio”, “Text”, “Image”, “Video”, “File”]
// }
export function createThread (data, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/CreateOrUpdateMessageThread',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: data
    })
  }